import AccessTime from "@mui/icons-material/AccessTime";
import AccountBalance from "@mui/icons-material/AccountBalance";
import AccountCircle from "@mui/icons-material/AccountCircle";
import Add from "@mui/icons-material/Add";
import AddLocationAlt from "@mui/icons-material/AddLocationAlt";
import AddPhotoAlternate from "@mui/icons-material/AddPhotoAlternate";
import AdminPanelSettings from "@mui/icons-material/AdminPanelSettings";
import Api from "@mui/icons-material/Api";
import ArrowBack from "@mui/icons-material/ArrowBack";
import ArrowCircleDown from "@mui/icons-material/ArrowCircleDown";
import ArrowCircleUp from "@mui/icons-material/ArrowCircleUp";
import ArrowDownward from "@mui/icons-material/ArrowDownward";
import ArrowForward from "@mui/icons-material/ArrowForward";
import ArrowUpward from "@mui/icons-material/ArrowUpward";
import Article from "@mui/icons-material/Article";
import AttachMoney from "@mui/icons-material/AttachMoney";
import AutoAwesome from "@mui/icons-material/AutoAwesome";
import Block from "@mui/icons-material/Block";
import Build from "@mui/icons-material/Build";
import Business from "@mui/icons-material/Business";
import CalendarMonth from "@mui/icons-material/CalendarMonth";
import CancelIcon from "@mui/icons-material/Cancel";
import ChatBubbleOutline from "@mui/icons-material/ChatBubbleOutlined";
import CheckCircleOutline from "@mui/icons-material/CheckCircleOutlined";
import Clear from "@mui/icons-material/Clear";
import Close from "@mui/icons-material/Close";
import CloudUpload from "@mui/icons-material/CloudUpload";
import Compare from "@mui/icons-material/Compare";
import Construction from "@mui/icons-material/Construction";
import ContentCopy from "@mui/icons-material/ContentCopy";
import CreditCard from "@mui/icons-material/CreditCard";
import DeleteForever from "@mui/icons-material/DeleteForever";
import Description from "@mui/icons-material/Description";
import Done from "@mui/icons-material/Done";
import DoneAll from "@mui/icons-material/DoneAll";
import DriveFileRenameOutline from "@mui/icons-material/DriveFileRenameOutline";
import Email from "@mui/icons-material/Email";
import ErrorOutline from "@mui/icons-material/ErrorOutlined";
import Euro from "@mui/icons-material/Euro";
import FilterAlt from "@mui/icons-material/FilterAlt";
import FormatListBulleted from "@mui/icons-material/FormatListBulleted";
import GppBad from "@mui/icons-material/GppBad";
import GppGood from "@mui/icons-material/GppGood";
import HelpOutline from "@mui/icons-material/HelpOutlined";
import HighlightOff from "@mui/icons-material/HighlightOff";
import Image from "@mui/icons-material/Image";
import Info from "@mui/icons-material/Info";
import Insights from "@mui/icons-material/Insights";
import Inventory from "@mui/icons-material/Inventory";
import Key from "@mui/icons-material/Key";
import Language from "@mui/icons-material/Language";
import LockClock from "@mui/icons-material/LockClock";
import Logout from "@mui/icons-material/Logout";
import ManageAccounts from "@mui/icons-material/ManageAccounts";
import Menu from "@mui/icons-material/Menu";
import MenuBook from "@mui/icons-material/MenuBook";
import Message from "@mui/icons-material/Message";
import ModeEdit from "@mui/icons-material/ModeEdit";
import MoreHoriz from "@mui/icons-material/MoreHoriz";
import OpenInNew from "@mui/icons-material/OpenInNew";
import Person from "@mui/icons-material/Person";
import PersonAdd from "@mui/icons-material/PersonAdd";
import PersonSearch from "@mui/icons-material/PersonSearch";
import Phone from "@mui/icons-material/Phone";
import PhoneAndroid from "@mui/icons-material/PhoneAndroid";
import Place from "@mui/icons-material/Place";
import PlaylistRemoveIcon from "@mui/icons-material/PlaylistRemove";
import Publish from "@mui/icons-material/Publish";
import RadioButtonUnchecked from "@mui/icons-material/RadioButtonUnchecked";
import Refresh from "@mui/icons-material/Refresh";
import RemoveModerator from "@mui/icons-material/RemoveModerator";
import RestartAlt from "@mui/icons-material/RestartAlt";
import Search from "@mui/icons-material/Search";
import SentimentSatisfiedAlt from "@mui/icons-material/SentimentSatisfiedAlt";
import SentimentVeryDissatisfied from "@mui/icons-material/SentimentVeryDissatisfied";
import Settings from "@mui/icons-material/Settings";
import Share from "@mui/icons-material/Share";
import Shield from "@mui/icons-material/Shield";
import SquareFoot from "@mui/icons-material/SquareFoot";
import Star from "@mui/icons-material/Star";
import Summarize from "@mui/icons-material/Summarize";
import SwapVert from "@mui/icons-material/SwapVert";
import TableView from "@mui/icons-material/TableView";
import ThreeP from "@mui/icons-material/ThreeP";
import Timer from "@mui/icons-material/Timer";
import Verified from "@mui/icons-material/Verified";
import VerifiedUser from "@mui/icons-material/VerifiedUser";
import Videocam from "@mui/icons-material/Videocam";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import WarningAmber from "@mui/icons-material/WarningAmber";
import WebAsset from "@mui/icons-material/WebAsset";
import ZoomIn from "@mui/icons-material/ZoomIn";
import ZoomOut from "@mui/icons-material/ZoomOut";

/*
	Re-exporting MUI icons with specific names.

	There are many slight variations of each MUI icon, and some icons are included
	multiple times under different names, so this is the canonical set of icons
	we use in Mainsail.
*/

export const AccountantIcon = AccountBalance;
export const AddIcon = Add;
export const AddImageIcon = AddPhotoAlternate;
export const AddLocationIcon = AddLocationAlt;
export const AdminIcon = AdminPanelSettings;
export const AiIcon = AutoAwesome;
export const AllowIcon = Done;
export const ApiIcon = Api;
export const ArchiveIcon = Inventory;
export const ArrowDownIcon = ArrowDownward;
export const ArrowLeftIcon = ArrowBack;
export const ArrowRightIcon = ArrowForward;
export const ArrowUpIcon = ArrowUpward;
export const ArticleIcon = Article;
export const BillingIcon = CreditCard;
export const BlockIcon = Block;
export const BrokerSubscriptionBadgeIcon = Verified;
export const BuilderIcon = Build;
export const CancelSubscriptionIcon = HighlightOff;
export const ClearIcon = Clear;
export const CloneIcon = ContentCopy;
export const CloseIcon = Close;
export const CmsIcon = MenuBook;
export const CompanyAdminIcon = Star;
export const CompanyIcon = Business;
export const CompareIcon = Compare;
export const CopyIcon = ContentCopy;
export const CreateIcon = Add;
export const CredentialsIcon = Key;
export const CurrentPlanIcon = Star;
export const DashboardIcon = Insights;
export const DateIcon = CalendarMonth;
export const DeleteIcon = DeleteForever;
export const DevIcon = Construction;
export const DimensionIcon = SquareFoot;
export const DistributionIcon = Share;
export const DowngradeIcon = ArrowCircleDown;
export const DraftIcon = DriveFileRenameOutline;
export const EditIcon = ModeEdit;
export const EmailDeliveredIcon = Done;
export const EmailErrorIcon = ErrorOutline;
export const EmailIcon = Email;
export const EmailOpenedIcon = DoneAll;
export const EnquiryIcon = Email;
export const ErrorIcon = ErrorOutline;
export const EurIcon = Euro;
export const ExcludedItemIcon = CancelIcon;
export const ExcludedItemListIcon = PlaylistRemoveIcon;
export const ExternalLinkIcon = OpenInNew;
export const FeaturedItemIcon = Star;
export const FeaturedItemListIcon = Star;
export const FilterIcon = FilterAlt;
export const FleetAuthorizedIcon = GppGood;
export const FleetUnauthorizedIcon = GppBad;
export const FriendlyIcon = SentimentSatisfiedAlt;
export const HamburgerMenuIcon = Menu;
export const HeadOfficeIcon = Star;
export const HelpIcon = HelpOutline;
export const HiddenIcon = VisibilityOff;
export const HidePasswordIcon = VisibilityOff;
export const IframeIcon = WebAsset;
export const ImageIcon = Image;
export const InfoIcon = Info;
export const ItineraryIcon = FormatListBulleted;
export const ListIcon = FormatListBulleted;
export const LocationIcon = Place;
export const ManageIcon = Settings;
export const ManageUsersIcon = ManageAccounts;
export const MapIcon = Place;
export const MeasurementIcon = SquareFoot;
export const MessageIcon = Message;
export const MoreIcon = MoreHoriz;
export const PasswordIcon = Key;
export const PaymentMethodIcon = CreditCard;
export const PendingAccessRequestIcon = LockClock;
export const PersonAddIcon = PersonAdd;
export const PersonIcon = Person;
export const PersonSearchIcon = PersonSearch;
export const PhoneMobileIcon = PhoneAndroid;
export const PhoneOfficeIcon = Phone;
export const PlaceIcon = Place;
export const PreviewIcon = Visibility;
export const PrimaryPaymentCardIcon = Star;
export const ProfileIcon = AccountCircle;
export const ProposalIcon = Description;
export const PublishIcon = Publish;
export const QuestionIcon = HelpOutline;
export const RefreshIcon = Refresh;
export const ReportIcon = Summarize;
export const ResetIcon = RestartAlt;
export const SearchIcon = Search;
export const SettingsIcon = Settings;
export const ShareIcon = Share;
export const ShieldIcon = Shield;
export const ShieldOffIcon = RemoveModerator;
export const ShowIcon = Visibility;
export const SignOutIcon = Logout;
export const SignUpRequestIcon = ThreeP;
export const SortIcon = SwapVert;
export const SpecialOfferIcon = Star;
export const SpokenLanguageIcon = ChatBubbleOutline;
export const StarIcon = Star;
export const SuccessIcon = CheckCircleOutline;
export const TableIcon = TableView;
export const TimeIcon = AccessTime;
export const TimerIcon = Timer;
export const UncheckedIcon = RadioButtonUnchecked;
export const UnfriendlyIcon = SentimentVeryDissatisfied;
export const UpgradeIcon = ArrowCircleUp;
export const UploadIcon = CloudUpload;
export const UsdIcon = AttachMoney;
export const UserProfileIcon = Person;
export const VerifiedIcon = VerifiedUser;
export const VideoIcon = Videocam;
export const ViewIcon = Visibility;
export const WarningIcon = WarningAmber;
export const WebsiteIcon = Language;
export const ZoomInIcon = ZoomIn;
export const ZoomOutIcon = ZoomOut;
